export const importConstants = {
  GET_TEMPLATE_REQUEST: 'IMPORT_GET_TEMPLATE_REQUEST',
  GET_TEMPLATE_SUCCESS: 'IMPORT_GET_TEMPLATE_SUCCESS',
  GET_TEMPLATE_FAILURE: 'IMPORT_GET_TEMPLATE_FAILURE',
  
  IMPORT_FILE_REQUEST: 'IMPORT_FILE_REQUEST',
  IMPORT_FILE_SUCCESS: 'IMPORT_FILE_SUCCESS',
  IMPORT_FILE_FAILURE: 'IMPORT_FILE_FAILURE',
  
  RESET_IMPORT: 'IMPORT_RESET'
};